import React from 'react';
import { createUseStyles } from 'react-jss';

import Text from '../../../components/Text';
import clsx from 'clsx';
import { Twig } from '../../../types';
import { getRatingColor } from '../../../lib/utils';

export interface RatingProps {
  twig: Twig;
  cardClassName?: string;
  cardInnerBoxClassName?: string;
}

const Rating: React.FC<RatingProps> = ({
  twig,
  cardClassName,
  cardInnerBoxClassName,
}) => {
  const classes = useStyles();
  return (
    <>
      <div className={clsx(classes.ratingsBox, 'mt-1')}>
        <div
          className={clsx(classes.ratingCard, cardClassName)}
          style={{ backgroundColor: getRatingColor(twig.qualityScore) }}
        >
          <div className={clsx(classes.ratingCardInner, cardInnerBoxClassName)}>
            <Text className={classes.ratingTitle}  as="span" color="white">
              Quality
            </Text>
            <Text className={classes.ratingScore} color="white" as="span" align="right" bold>
              {twig.qualityScore}
            </Text>
          </div>
        </div>
        {twig.business==null || twig.business?.type=='NORMAL' ? (
       <div
        className={clsx(classes.ratingCard, cardClassName)}
        style={{ backgroundColor: getRatingColor(twig.serviceScore) }}
       >
        <div className={clsx(classes.ratingCardInner, cardInnerBoxClassName)}>
          <Text className={classes.ratingTitle} as="span" color="white">
            Service
          </Text>
          <Text className={classes.ratingScore} color="white" as="span" align="right" bold>
            {twig.serviceScore}
          </Text>
        </div>
      </div>) : null}

 
        <div
          className={clsx(classes.ratingCard, cardClassName)}
          style={{ backgroundColor: getRatingColor(twig.priceScore) }}
        >
          <div className={clsx(classes.ratingCardInner, cardInnerBoxClassName)}>
            <Text className={classes.ratingTitle} as="span" color="white">
              Price
            </Text>
            <Text className={classes.ratingScore} as="span" color="white" align="right" bold>
              {twig.priceScore}
            </Text>
          </div>
        </div>
      {twig.business==null || twig.business?.type=='NORMAL' ? (
        <div
        className={clsx(classes.ratingCard, cardClassName)}
        style={{ backgroundColor: getRatingColor(twig.ambianceScore) }}
        >
          <div className={clsx(classes.ratingCardInner, cardInnerBoxClassName)}>
            <Text className={classes.ratingTitle} as="span" color="white">
              Ambiance
            </Text>
            <Text className={classes.ratingScore} as="span" color="white" align="right" bold>
              {twig.ambianceScore}
            </Text>
          </div>
        </div>
      ) : null}
      </div>
    </>
  );
};

const useStyles = createUseStyles({
  ratingsBox: {},
  ratingCard: {
    padding: '10px',
    borderRadius: '5px',
    display: 'inline-block',
    justifyContent: 'space-between',
    alignItems: 'center',
    minWidth: '128px',
    color: '#212529',
    marginRight: '10px',
    marginTop: '10px',
  },
  ratingCardInner: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  ratingTitle: {},
  ratingScore: {},
});

export default Rating;
